import Swiper from "swiper";

export default class {
    constructor() {
        document.addEventListener("DOMContentLoaded", function () {
            var swiper = new Swiper(".swiper-events", {
                centeredSlides: false,
                slidesPerView: "auto",
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: true,
                },
                loop: false,
                breakpoints: {
                    // when window width is >= 320px
                    0: {
                        spaceBetween: 10,
                    },
                    // when window width is >= 480px
                    1024: {
                        spaceBetween: 30,
                    },
                },
            });
        });
    }
}
